import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=fba120fc&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=fba120fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba120fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fba120fc')) {
      api.createRecord('fba120fc', component.options)
    } else {
      api.reload('fba120fc', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=fba120fc&scoped=true&", function () {
      api.rerender('fba120fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Fr1xFMxbuS2a/JS/comp/PopupDialog.vue"
export default component.exports